import React, { useState, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'hooks/redux'
import {
  getShowHarnesses,
  getFeatureHarnessFloatingCircuits,
} from 'selectors/feature/harnesses'
import { isEmpty } from 'ramda'

import strings from 'utils/strings'

import {
  StyledSelectMenu,
  StyledRadioGroup,
} from './FixedOrFloatingEditor.style'

const getRadioOptions = (floatingOptions) => [
  {
    key: 0,
    name: 'pins',
    value: 0,
    text: strings.fixed_pin,
    disabled: false,
  },
  {
    key: 1,
    value: 1,
    name: 'circuits',
    text: strings.floating_circuit,
    disabled: isEmpty(floatingOptions),
    showTooltip: isEmpty(floatingOptions),
    tooltipConfig: {
      title: strings.floating_circuit_disabled_tooltip,
      placement: 'bottom',
    },
  },
]

const FIXED = 0
const FLOATING = 1

const getInitialState = (floatingValue) => {
  if (floatingValue) return FLOATING

  return FIXED
}

const mapOption = (value) => ({ key: value, value, title: value })

const FixedOrFloatingEditor = ({
  floatingValue,
  onFloatingChange,
  floatingActive,
  floatingRules,
  children,
  subType,
  outputCurrent,
}) => {
  const [selection, setSelection] = useState(getInitialState(floatingValue))

  const handleSelect = (e) => {
    setSelection(e.target.value)
  }
  const floatingOptions = useSelector(getFeatureHarnessFloatingCircuits, {
    subType,
    outputCurrent,
  })
  const showHarnesses = useSelector(getShowHarnesses)

  const floatingOptionsMapped = useMemo(() => floatingOptions.map(mapOption), [
    floatingOptions,
  ])

  useEffect(() => {
    if (
      selection === FLOATING &&
      (isEmpty(floatingOptions) || !floatingActive)
    ) {
      setSelection(FIXED)
    }
  }, [floatingOptions, selection, floatingActive])

  return (
    <>
      {showHarnesses && floatingActive && (
        <>
          <StyledRadioGroup
            horizontal
            onChange={handleSelect}
            value={selection}
            options={getRadioOptions(floatingOptions)}
          />
          {selection === FLOATING && (
            <StyledSelectMenu
              name={strings.floating_circuit}
              onChange={onFloatingChange}
              value={floatingValue}
              options={floatingOptionsMapped}
              rules={floatingRules}
              mask={strings.floating_circuit_mask}
              showSearch
            />
          )}
        </>
      )}

      {selection === FIXED && children}
    </>
  )
}

FixedOrFloatingEditor.propTypes = {
  floatingValue: PropTypes.string,
  onFloatingChange: PropTypes.func,
  floatingActive: PropTypes.bool, // TODO: change this?
  floatingRules: PropTypes.object,
  subType: PropTypes.string,
  outputCurrent: PropTypes.number,
  /** this will be the fixed pin select menu */
  children: PropTypes.node,
}

export default FixedOrFloatingEditor
